
<div>1</div>
<div class="tc-ag-grid-indicator tc-ag-grid-indicator--danger" matTooltip="{{'Invalid Inputs' | translate}}" matTooltipPosition="right"
     aria-label="indicator tooltip" matTooltipClass="mat-tooltip--large mat-tooltip--danger">
</div>
